import React from 'react';
import { useMarketingEmailSettings } from '../hooks/use-marketing-email-settings.js';
import MarketingEmailSettingsPageView from './marketing-email-settings-page-view.jsx';

function MarketingEmailSettingsPageContainer() {
  const state = useMarketingEmailSettings();
  return <MarketingEmailSettingsPageView {...state} />;
}

export default MarketingEmailSettingsPageContainer;
